import React, {
  useReducer,
  useState,
  useEffect,
  useContext,
  useCallback,
} from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';

import FilterAutoComplete from 'components/filter/FilterAutoComplete';
import Map from '../components/map/Map';
import Permission from 'components/permissions/Permission';
import Filter from 'components/filter/Filter';
import Search from '@material-ui/icons/Search';
import SimpleTable from '../components/table/Table';
import TableMenu, { TableColumn } from 'components/table/TableMenu';
import ModalObs from 'components/modals/ModalObs';
import { CommandUnified } from '../components/commands/Commands';
import CommandSafeloggyModal from '../components/commands/CommandSafeloggyModal';
import CommandSafeloggySOSAndBlockModal from '../components/commands/CommandSafeloggySOSAndBlockModal';
import CommandLockModal from '../components/commands/CommandLockModal';
import InputAdornment from '@material-ui/core/InputAdornment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Typography from '@material-ui/core/Typography';
import { StatusColumn } from 'components/table/columns';
import theme from 'styles/theme';
import TableHeader from 'components/table/TableHeader';
import TableHeaderAction from 'components/table/TableHeaderAction';
import { List } from '@material-ui/icons';
import ModalSetUserMapFieldsAvailable from 'components/modals/ModalSetUserMapFieldsAvailable';
import Chip from '@material-ui/core/Chip';
import Fade from '@material-ui/core/Fade';
import CloseIcon from '@material-ui/icons/Close';

import BatteryIcon from '../assets/icon/battery.svg';

import { fetchAuthenticated } from 'services/fetch';
import { useAccessLog } from 'hooks/logs';
import { useQuery } from 'hooks/fetch';
import { emitEvent } from 'utils/events';

import { saveAs } from 'file-saver';
import { logAction } from 'utils/logs';

import {
  datetimeFormatter,
  percentageFormatter,
  latlongFormatter,
  poffFormatter,
} from 'utils/formatters';
import {
  isRfOn,
  formatMapPositionLabel,
  minutesToTimeString,
  getBatteryStatus,
  formatCommunicationType,
} from 'utils/helpers';

import HomeFilterContext from 'pages/HomeFilterContext';
import FilterHandler from 'utils/FilterHandler';

async function fetchData(path) {
  let data = null;
  emitEvent('showGlobalLinearProgress');

  const response = await fetchAuthenticated('GET', path);
  if (response.ok) data = await response.json();

  emitEvent('hideGlobalLinearProgress');
  return data;
}

function reduce(state, action) {
  switch (action.type) {
    case 'SET':
      return action.payload;
    default:
      return state;
  }
}

function Mapa(props) {
  const filterContext = useContext(HomeFilterContext);

  const genericSearchFields = [
    { label: 'Imei', name: 'imei' },
    { label: 'Código', name: 'code' },
    { label: 'Descrição', name: 'description' },
    { label: 'Tipo', name: 'equipmentType.name' },
    { label: 'Nome da Empresa', name: 'currentCompany.name' },
    // { label: 'Cidade', name: 'currentCompany.addressCity.nome', },
    // { label: 'Estado', name: 'currentCompany.addressState.nome', },
    {
      label: 'Placa / LP',
      name: 'vehicle',
    },
    { label: 'Local', name: 'lastEvent.local' },
    { label: 'Ponto de Referência', name: 'lastEvent.referencePointLocal' },
    { label: 'Observação', name: 'lastObservation.text' },
  ];

  useAccessLog('Acesso ao mapa');
  const { classes, location } = props;
  const path = 'equipment';

  const [modalMapFieldsAvailable, setModalMapFieldsAvailable] = useState(false);
  // const [fetchPath, setFetchPath] = useState(buildUrl(path, location, {sort: {'lastEvent.timestamp': -1}}));

  // const [query, setQuery] = useState(buildQuery(location, {filter: {currentCompany: {'$exists': true}}}))

  const [reload, setReload] = useState(false);
  // Fetch and re-fetch data every time `fetchPath` changes
  const [data, dispatch] = useReducer(reduce, false);

  const [userData, setUserData] = useState({});

  const [userMapFieldsAvailable, setUserMapFieldsAvailable] = useState({});

  const [chips, setChips] = useState(
    (filterContext && filterContext.searchTerm) || []
  );

  const selectedCompanies =
    filterContext && Array.isArray(filterContext.companies) && filterContext.companies.length
      ? filterContext.companies
      : filterContext && filterContext.company
      ? [filterContext.company]
      : [];
  
    const selectedCompanyIds = selectedCompanies
    .map(company => (company && company._id ? company._id : null))
    .filter(id => id);

    const currentCompanyFilter = selectedCompanyIds.length
    ? { $in: selectedCompanyIds.map(id => ({ value: id, toObjectId: false })) }
    : { $exists: true };

  const [modalProfileFieldsAvailable, setModalProfileFieldsAvailable] =
    useState(false);

  const [query, setQuery, isLoading, refreshQuery] = useQuery(
    path,
    data => dispatch({ type: 'SET', payload: data }),
    undefined,
    {
      filter: {
        'currentCompany._id': currentCompanyFilter,
        lastEvent: { $exists: true },
        isActive: true,
        ...(filterContext.equipment && { _id: filterContext.equipment._id }),
        ...(filterContext.searchTerm && {
          searchText: filterContext.searchTerm,
          genericSearchFields: genericSearchFields.map(field => field.name),
          searchTextMode: 'or',
        }),
      },
      sort: {
        'lastEvent.timestamp': -1,
      },
    },
    undefined,
    reload
  );
  const [centerMapOn, setCenterMapOn] = useState(null);

  const onModalObsSubmit = () => {
    setReload(!reload);
  };

  useEffect(() => {
    const INTERVAL = 1000 * 60;
    let RELOAD_INTERVAL_REFERENCE = null;

    if (filterContext) {
      filterContext.updateSearchTerm(query.queryObject.filter.searchText);
    }

    const fn = async () => {
      RELOAD_INTERVAL_REFERENCE = setInterval(async () => {
        refreshQuery(query);
      }, INTERVAL);
    };
    fn();

    return () => clearInterval(RELOAD_INTERVAL_REFERENCE);
  }, [query]);

  useEffect(() => {
    const fn = async () => {
      const userData = await fetchAuthenticated(
        'get',
        `user/${JSON.parse(localStorage.getItem('user'))._id}`
      );
      if (userData.ok) {
        userData.json().then(__userData => {
          setUserData(__userData);

          setUserFieldsList(__userData);
        });
      }
    };

    fn();
  }, []);

  const lockCommandAction = {
    label: 'Comandos Cadeado',
    permission: 'SendLockCommand',
    component: (props, setCurrentAction) => (
      <CommandLockModal
        isOpen
        setCurrentAction={setCurrentAction}
        lock={props.lock}
        {...props}
      />
    ),
  };

  const rowActions = [
    {
      label: 'Comandos',
      permissions: ['SendGPRSCommand', 'SendAdminCommand'],
      component: props => (
        <CommandUnified showStatus={true} isVisible={true} {...props} />
      ),
    },
    {
      label: 'Observações',
      permission: 'EditEquipmentObservations',
      component: props => (
        <ModalObs
          onSubmit={onModalObsSubmit}
          equipment={props}
          isVisible={true}
          {...props}
        />
      ),
    },
  ];

  const safeloggyRowActions = [
    {
      label: 'Comandos Bloqueador',
      permission: 'SendSafeloggyCommand',
      component: (props, setCurrentAction) => (
        <CommandSafeloggyModal
          isOpen
          setCurrentAction={setCurrentAction}
          {...props}
        />
      ),
    },
    {
      label: 'Bloqueador SOS e Bloqueio',
      permission: 'SendSafeloggyCommand',
      component: (props, setCurrentAction) => (
        <CommandSafeloggySOSAndBlockModal
          isOpen
          setCurrentAction={setCurrentAction}
          {...props}
        />
      ),
    },
    {
      label: 'Observações',
      permission: 'EditEquipmentObservations',
      component: props => (
        <ModalObs
          onSubmit={onModalObsSubmit}
          equipment={props}
          isVisible={true}
          {...props}
        />
      ),
    },
  ];

  const columns = [
    {
      label: 'Equip.',
      value: row => row.shortImei,
      sort: 'shortImei',
      identifier: 'equipment',
    },
    {
      label: 'Placa / LP',
      headerStyle: { 'whiteSpace': 'nowrap' },
      value: row => row.vehicle,
      sort: 'vehicle',
      identifier: 'plate',
    },
    {
      label: 'Tipo',
      value: row => row.equipmentType && row.equipmentType.name,
      sort: 'equipmentType.name',
      identifier: 'type',
    },
    {
      label: 'Embalagem',
      value: row => (row.packing && row.packing.name) || '-',
      sort: 'packing.name',
      identifier: 'packing',
    },
    {
      label: 'Comunicação',
      value: row => formatCommunicationType((row.lastEventEquipment || row.lastEvent || {}).communicationType) || '-',
      sort: 'lastEventEquipment.communicationType',
      identifier: 'communicationType',
    },
    {
      label: 'Empresa',
      value: row => row.currentCompany && row.currentCompany.name,
      sort: 'currentCompany.name',
      identifier: 'company',
    },
    {
      label: 'Operadora',
      value: row => row.lastEvent && row.lastEvent.cellIdMncName,
      sort: 'lastEvent.cellIdMncName',
      identifier: 'operator',
    },
    {
      label: 'Chip',
      value: row => {
        return (row.mobileOperator && row.mobileOperator.name) || '-';
      },
      sort: 'mobileOperator.name',
      identifier: 'chip',
    },
    {
      label: 'V. FW',
      value: row => ((row.lastEventEquipment || row.lastEvent || {}).firmwareVersion) || '-',
      sort: 'lastEventEquipment.firmwareVersion',
      identifier: 'firmwareVersion',
    },
    {
      label: 'Bat.',
      value: row => (
        <div className={classes.chargingBattery}>
          <span>
            {((row.lastEventEquipment || row.lastEvent) &&
              percentageFormatter(
                Number(
                  ((row.lastEventEquipment || row.lastEvent).adjustedInternalBatteryPercentage ||
                    (row.lastEventEquipment || row.lastEvent).internalBatteryPercentage) / 100
                )
              )) ||
              '-'}
          </span>
          {getBatteryStatus(row.lastEventEquipment || row.lastEvent) && (
            <img
              src={BatteryIcon}
              style={{ marginLeft: '10px' }}
              alt="Carregando"
            />
          )}
        </div>
      ),
      sort: 'lastEventEquipment.internalBatteryPercentage',
      identifier: 'battery',
    },
    {
      label: 'Exp.',
      value: row => poffFormatter(row),
      identifier: 'expiration',
    },
    {
      label: 'Posição',
      value: row => row.lastEvent && formatMapPositionLabel(row.lastEvent, true),
      identifier: 'position',
    },
    {
      label: 'Sinal',
      value: row => {
        const ev = row.lastEventEquipment || row.lastEvent;
        return ev && ev.gsmModelSignal &&
        `${Math.round(
          (parseInt(ev.gsmModelSignal, 10) / 31) * 100
        )}%`;
      },
      sort: 'lastEventEquipment.gsmModelSignal',
      identifier: 'signal',
    },
    {
      label: 'Data/hora',
      value: row =>
        (row.lastEvent && `${datetimeFormatter(row.lastEvent.timestamp)}`) ||
        '-',
      sort: 'lastEvent.timestamp',
      identifier: 'datetime',
    },
    { label: 'RF', value: row => isRfOn(row.lastEventEquipment || row.lastEvent), identifier: 'rf' },
    {
      label: 'FPP.',
      value: row => {
        const ev = row.lastEventEquipment || row.lastEvent;
        return ev && minutesToTimeString(ev.positionSendInterval);
      },
      sort: 'lastEventEquipment.positionSendInterval',
      identifier: 'fpp',
    },
    {
      label: 'Local',
      // value: row => row.lastEvent && row.lastEvent.local,
      value: row =>
        'isInsideReferencePoint' in row.lastEvent &&
        row.lastEvent.isInsideReferencePoint
          ? row.lastEvent.referencePointLocal
          : row.lastEvent.local,
      sort: 'lastEvent.local',
      identifier: 'local',
    },
    {
      label: 'Lat/Long',
      value: row =>
        (row.lastEvent &&
          `${latlongFormatter(
            row.lastEvent.latitude,
            row.lastEvent.longitude
          )}`) ||
        '-/-',
      sort: '',
      identifier: 'latlong',
    },
    // {
    //   label: 'ID Módulo LORA',
    //   value: row =>
    //     ((row.lastLoraModuleId && row.lastLoraModuleId) &&
    //       `${row.lastLoraModuleId}`) ||
    //     '-',
    //   sort: '',
    //   identifier: 'loraModuleId',
    // },
    {
      label: 'Status',
      component: row => (
        <TableColumn>
          <StatusColumn
            edit={false}
            // status={row.handlingStatus}
            status={row.currentHandlingStatus}
            dashboardCard={row.currentDashboardCard}
          />
        </TableColumn>
      ),
      identifier: 'status',
    },
  ];

  const setColumns = () => {
    if (JSON.stringify(userData) !== '{}') {
      if (
        userData.hasOwnProperty('userMapFieldsAvailable') &&
        userData.userMapFieldsAvailable.length > 0
      ) {

        let columnIndex = 0;
        for(const [key, value] of Object.entries(userData.userMapFieldsAvailable[0])) {
          const idx = columns.findIndex(x => x.identifier === key);
          if(idx === -1) {
            columnIndex++;
            continue;
          }
          if(typeof value === 'boolean') {
            if(value === false) {
              columns.splice(idx, 1);
            } else {
              columns[idx].index = columnIndex;
            }
          } else if(typeof value === 'object') {
            if(value.checked === false) {
              columns.splice(idx, 1);
            } else {
              columns[idx].index = value.index;
            }
          }
          
          columnIndex++;
        }
      }
    }
  };

  setColumns();
  columns.sort((a, b) => a.index - b.index);

  columns.push({
    label: '',
    component: (row, col) => (
      <Permission
        key={row._id}
        names={[
          'SendGPRSCommand',
          'SendAdminCommand',
          'EditEquipmentObservations',
        ]}
      >
        <TableMenu
          row={row}
          rowActions={
            row.equipmentType.name === 'Bloqueador'
              ? safeloggyRowActions
              : row.lock
              ? [...rowActions, lockCommandAction]
              : rowActions
          }
          icon={<MoreVertIcon />}
        />
      </Permission>
    ),
  })


  const handleCompanySelectionChange = useCallback(
    selected => {
      const normalizedSelected = Array.isArray(selected)
        ? selected.filter(company => company)
        : [];

      if (filterContext && typeof filterContext.updateCompanies === 'function') {
        filterContext.updateCompanies(normalizedSelected);
      }

      const companyIds = normalizedSelected
        .map(company => (company && company._id ? company._id : null))
        .filter(id => id);

      const handler = new FilterHandler(query, setQuery, location);

      if (!companyIds.length) {
        handler.removeFilter('currentCompany._id');
        return;
      }

      handler.updateQueryFilter({
        currentCompany: { $exists: true },
        'currentCompany._id': {
          $in: companyIds.map(id => ({ value: id, toObjectId: false })),
        },
        isActive: true,
      });
    },
    [filterContext, query, setQuery, location]
  );



  const handleRemoveCompany = useCallback(
    company => {
      const companyId = company && company._id;
      const companyName = company && company.name;
      const remainingCompanies = selectedCompanies.filter(item => {
        if (!item) {
          return false;
        }

        if (companyId) {
          return item._id !== companyId;
        }

        const itemKey = item._id || item.name;
        const targetKey = companyId || companyName;
        return itemKey !== targetKey;
      });
      handleCompanySelectionChange(remainingCompanies);
    },
    [selectedCompanies, handleCompanySelectionChange]
  );

  const renderSearchAndCompanyChips = useCallback(
    ({ chips: searchChips, handleDelete, classes: filterClasses }) => (
      <>
        {searchChips.map((item, index) => (
          <Fade key={`search-${item}-${index}`} in={true} timout={1000}>
            <Chip
              label={item}
              clickable
              color="primary"
              onDelete={() => {
                handleDelete(item);
              }}
              deleteIcon={<CloseIcon style={{ width: 15 }} />}
              variant="outlined"
              className={filterClasses.chip}
            />
          </Fade>
        ))}

        {selectedCompanies.map(company => {
          if (!company) {
            return null;
          }

          const label = company.name || '';
          const key = `company-${company._id || label}`;
          return (
            <Fade key={key} in={true} timout={1000}>
              <Chip
                label={label}
                clickable
                color="primary"
                onDelete={() => handleRemoveCompany(company)}
                deleteIcon={<CloseIcon style={{ width: 15 }} />}
                variant="outlined"
                className={filterClasses.chip}
              />
            </Fade>
          );
        })}
      </>
    ),
    [selectedCompanies, handleRemoveCompany]
  );

  
  const filterAsyncFields = [
    {

      name: 'companies',
      component: args => (
        <FilterAutoComplete
          {...args}
          menuContainerStyle={{
            marginTop: 5,
          }}
          placeholder="Empresa"
          showPlaceholder={true}
          hideLabel={true}
          path="company?notPaginated=true&fields=_id,name"
          name="companies"
          getOptionLabel={opt => opt.name}
          loadingMessage="Carregando empresas..."
          noOptionsMessage="Nenhuma empresa encontrada."
          isMulti={true}
          controlShouldRenderValue={false}
          onChange={args => {
            const { opt, setIsLoading, isLoading } = args;
            // reset equipments filter
            // fields.equipments.current.resetField();
            setIsLoading({ ...isLoading, equipments: true });
            const selected = Array.isArray(opt) ? opt : opt ? [opt] : [];
            handleCompanySelectionChange(selected.filter(item => item));
          }}
          value={(filterContext && filterContext.companies) || []}
        />
      ),
    },
    // {
    //   name: 'equipments',
    //   component: args => (
    //     <FilterAutoComplete
    //       {...args}
    //       menuContainerStyle={{
    //         marginTop: 5,
    //       }}
    //       placeholder="Equipamentos"
    //       showPlaceholder={true}
    //       hideLabel={true}
    //       path="equipment?notPaginated=true&fields=_id,imei&"
    //       additionalStartPath='filter={"isActive":true, "currentCompany._id": { "$exists": true }, "lastEvent": { "$exists": true }}'
    //       name="equipments"
    //       getOptionLabel={opt => opt.imei}
    //       loadingMessage="Carregando equipamentos..."
    //       noOptionsMessage="Nenhum equipamento encontrado."
    //       onChange={args => {
    //         const { opt, filterHandler } = args;
    //         filterContext.updateEquipment(opt);
    //         if (!opt) {
    //           filterHandler.removeFilter('_id');
    //         } else {
    //           filterHandler.updateQueryFilter({
    //             currentCompany: { $exists: true },
    //             _id: opt._id,
    //             isActive: true,
    //           });
    //         }
    //       }}
    //       whenIsLoading={({ path: defaultPath, setFetchUrl, fields }) => {
    //         const companyField = fields.companies.current.value;
    //         if (companyField) {
    //           const _filter = {
    //             'currentCompany._id': {
    //               value: companyField._id,
    //               toObjectId: false,
    //             },
    //             isActive: true,
    //           };
    //           setFetchUrl(`${defaultPath}filter=${JSON.stringify(_filter)}`);
    //         } else {
    //           setFetchUrl(
    //             `${defaultPath}filter=${JSON.stringify({ isActive: true })}`
    //           );
    //         }
    //       }}
    //       value={filterContext.equipment}
    //     />
    //   ),
    // },
  ];


  const Popover = props => (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography style={{ fontSize: 15 }}>
          <b>Última observação:</b>{' '}
        </Typography>
        <Typography
          style={{
            fontSize: 14,
            marginLeft: 34,
            color: '#8e96b0',
            fontWeight: 'bold',
          }}
        >
          {datetimeFormatter(props.lastObservation.date)}
        </Typography>
      </div>
      <Typography style={{ fontSize: 14, marginTop: 17, color: '#41475a' }}>
        {props.lastObservation && props.lastObservation.text}
      </Typography>
    </>
  );

  const handleExportXLS = async query => {
    try {
      const response = await fetchAuthenticated(
        'GET',
        `equipment/report/xls${query.queryString}&reportIdentifier=map-report`
      );

      const blob = await response.blob();
      saveAs(blob, 'Relatorio_Equipamentos.xls');
      logAction('Exportou relatório de equipamentos do mapa em XLS');
    } catch (err) {
      console.log(err);
    }
  };

  const setUserFieldsList = async userData => {
    let __fields = [];

    if (userData.hasOwnProperty('userMapFieldsAvailable')) {
      try {

        let labelsDict = {
          equipment: 'Equipamento',
          plate: 'Placa / LP',
          type: 'Tipo',
          packing: 'Embalagem',
          communicationType: 'Comunicação',
          company: 'Empresa',
          firmwareVersion: 'Versão do Firmware',
          battery: 'Bateria',
          expiration: 'Expiração',
          position: 'Posição',
          signal: 'Sinal',
          datetime: 'Data e Hora',
          rf: 'RF',
          fpp: 'FPP',
          local: 'Local',
          latlong: 'Lat/Long',
          status: 'Status',
          loraModuleId: 'ID Módulo LORA',
          operator: 'Operadora',
          chip: 'Chip',
        }

        for(const [key, value] of Object.entries(userData.userMapFieldsAvailable[0])) {
          if(labelsDict[key] === undefined) {
            continue;
          }
          if(key === 'loraModuleId') {
            continue;
          }
          if(typeof value === 'boolean') {
            __fields.push({
              _id: key,
              label: labelsDict[key],
              checked: value,
              index: 0
            });
          } else if(typeof value === 'object') {
            __fields.push({
              _id: key,
              label: labelsDict[key],
              checked: value.checked,
              index: value.index,
            });
          }
        }

        if(!__fields.some(x => x.label === 'Operadora')) {
          __fields.push({
            _id: 'operator',
            label: 'Operadora',
            checked: true,
            index: __fields.length - 1,
          });
        }

        if(!__fields.some(x => x.label === 'Chip')) {
          __fields.push({
            _id: 'chip',
            label: 'Chip',
            checked: true,
            index: __fields.length - 1,
          });
        }

        if(!__fields.some(x => x.label === 'Embalagem')) {
          __fields.push({
            _id: 'packing',
            label: 'Embalagem',
            checked: true,
            index: __fields.length - 1,
          });
        }
        
        __fields.sort((a, b) => a.index - b.index);

      } catch (e) {
        __fields = [
          {
            _id: 'equipment',
            label: 'Equipamento',
            checked: true,
          },
          {
            _id: 'plate',
            label: 'Placa / LP',
            checked: true,
          },
          {
            _id: 'type',
            label: 'Tipo',
            checked: true,
          },
          {
            _id: 'packing',
            label: 'Embalagem',
            checked: true,
          },
          {
            _id: 'communicationType',
            label: 'Comunicação',
            checked: true,
          },
          {
            _id: 'company',
            label: 'Empresa',
            checked: true,
          },
          {
            _id: 'firmwareVersion',
            label: 'Versão do Firmware',
            checked: true,
          },
          {
            _id: 'battery',
            label: 'Bateria',
            checked: true,
          },
          {
            _id: 'expiration',
            label: 'Expiração',
            checked: true,
          },
          {
            _id: 'position',
            label: 'Posição',
            checked: true,
          },
          {
            _id: 'signal',
            label: 'Sinal',
            checked: true,
          },
          {
            _id: 'datetime',
            label: 'Data e Hora',
            checked: true,
          },
          {
            _id: 'rf',
            label: 'RF',
            checked: true,
          },
          {
            _id: 'fpp',
            label: 'FPP',
            checked: true,
          },
          {
            _id: 'local',
            label: 'Local',
            checked: true,
          },
          {
            _id: 'latlong',
            label: 'Lat/Long',
            checked: true,
          },
          {
            _id: 'status',
            label: 'Status',
            checked: true,
          },
          {
            _id: 'operator',
            label: 'Operadora',
            checked: true,
            index: __fields.length - 1,
          },
          {
            _id: 'chip',
            label: 'Chip',
            checked: true,
            index: __fields.length - 1,
          },
        ];
      }
    } else {
      __fields = [
        {
          _id: 'equipment',
          label: 'Equipamento',
          checked: true,
        },
        {
          _id: 'plate',
          label: 'Placa / LP',
          checked: true,
        },
        {
          _id: 'type',
          label: 'Tipo',
          checked: true,
        },
        {
          _id: 'packing',
          label: 'Embalagem',
          checked: true,
        },
        {
          _id: 'communicationType',
          label: 'Comunicação',
          checked: true,
        },
        {
          _id: 'company',
          label: 'Empresa',
          checked: true,
        },
        {
          _id: 'firmwareVersion',
          label: 'Versão do Firmware',
          checked: true,
        },
        {
          _id: 'battery',
          label: 'Bateria',
          checked: true,
        },
        {
          _id: 'expiration',
          label: 'Expiração',
          checked: true,
        },
        {
          _id: 'position',
          label: 'Posição',
          checked: true,
        },
        {
          _id: 'signal',
          label: 'Sinal',
          checked: true,
        },
        {
          _id: 'datetime',
          label: 'Data e Hora',
          checked: true,
        },
        {
          _id: 'rf',
          label: 'RF',
          checked: true,
        },
        {
          _id: 'fpp',
          label: 'FPP',
          checked: true,
        },
        {
          _id: 'local',
          label: 'Local',
          checked: true,
        },
        {
          _id: 'latlong',
          label: 'Lat/Long',
          checked: true,
        },
        {
          _id: 'status',
          label: 'Status',
          checked: true,
        },
        {
          _id: 'operator',
          label: 'Operadora',
          checked: true,
        },
        {
          _id: 'chip',
          label: 'Chip',
          checked: true,
        },
        {
          _id: 'packing',
          label: 'Embalagem',
          checked: true,
        },
      ];
    }

    setUserMapFieldsAvailable(__fields);
  };

  const onClickEditList = async () => {
    setModalMapFieldsAvailable(true);
  };

  const handleChangeColumns = async () => {
    const userData = await fetchAuthenticated(
      'get',
      `user/${JSON.parse(localStorage.getItem('user'))._id}`
    );
    if (userData.ok) {
      userData.json().then(__userData => {
        setUserData(__userData);

        setUserFieldsList(__userData);
      });
    }

    setColumns();
  };

  return (
    <div className={classes.root}>
      <ModalSetUserMapFieldsAvailable
        isVisible={modalMapFieldsAvailable}
        setIsVisible={setModalMapFieldsAvailable}
        userData={userData}
        currentProfileFieldsAvailableData={userMapFieldsAvailable}
        setCurrentProfileFieldsAvailableData={setUserMapFieldsAvailable}
        handleSave={handleChangeColumns}
      />
      <Filter
        searchPlaceHolder="Buscar (cidade, estado, equipamento, ponto de referência...)"
        path={path}
        query={query}
        setQuery={setQuery}
        containerStyle={{ paddingLeft: 0 }}
        asyncFields={filterAsyncFields}
        searchTextMode="or"
        inputProps={{
          startAdornment: (
            <InputAdornment position="start" className={classes.searchIcon}>
              <Search />
            </InputAdornment>
          ),
        }}
        showPlaceholder={true}
        hideLabel={true}
        genericSearchFields={genericSearchFields}
        defaultChips={chips}
        renderChips={renderSearchAndCompanyChips}
      />
      <Map
        height={320}
        containerStyle={{}}
        equipments={data}
        centerMapOn={centerMapOn}
        // showAllFences={true}
        showCurrentEquipmentFences={false}
      />
      <SimpleTable
        columns={columns}
        path={path}
        data={data}
        setQuery={setQuery}
        query={query}
        containerStyle={{ paddingLeft: 0, paddingRight: 0 }}
        onRowClick={(row, col) => {
          setCenterMapOn(row);
        }}
        HeaderComponent={
          <TableHeader
            headerActions={[
              <TableHeaderAction
                title="Exportar XLS"
                IconProps={{ style: theme.custom.icon }}
                Icon={props => <Typography {...props}>XLS</Typography>}
                disabled={data && data.totalItems === 0}
                onClick={() => handleExportXLS(query)}
              />,
              <TableHeaderAction
                title="Editar Visualização"
                Icon={List}
                // disabled={checkedList.length === 0 || filter !== 'received'}
                onClick={() => onClickEditList()}
              />,
            ]}
          />
        }
        popover={Popover}
        isPopoverVisible={row =>
          row.lastObservation && !row.lastObservation.archived
        }
      />
    </div>
  );
}

const styles = theme => ({
  root: {
    paddingLeft: theme.main.padding.left,
    paddingRight: theme.main.padding.right,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  mapClass: {
    marginTop: 50,
  },
  searchIcon: {
    color: theme.palette.gray.gray_5,
  },
  chargingBattery: {
    display: 'flex',
    alignItems: 'center',
  },
});
export default withRouter(withStyles(styles)(Mapa));

